//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: [{ title: 'Effective Date', filter: 'dateFull' }, { title: 'End Date', filter: 'dateFull' }, 'Fee / Percent', 'Initial', 'Daily', 'Start Day', '# of Days'],
            fields: ['starts_at', 'ends_at', 'is_flat_fee_display', 'initial_accounting_charge_code_factor', 'daily_accounting_charge_code_factor', 'number_of_start_day', 'number_of_days_to_run'],
            items: [],
            loading: true,
            lateFee: {
                number_of_start_day: 4,
                number_of_days_to_run: 15,
                balance_threshold: 100.00,
                percentage_cap: 0,
                is_initial_flat_fee: true,
                round_to_nearest_dollar: false,
                should_charge_lease_amount: true,
                starts_at: null,
                ends_at: null
            },
            chargeCodes: [],
            showForm: false
        };
    },


    methods: {
        load: function load() {
            var _this = this;

            this.$children[0].$data.showModal = true;
            Object.assign(this.$data, this.$options.data());
            axios.post('/prototype/accounting/charge-codes/list').then(function (response) {
                return _this.chargeCodes = response.data;
            });
            axios.get('/prototype/late-fees').then(function (response) {
                _this.items = response.data;
                _this.items.map(function (item) {
                    return item['is_flat_fee_display'] = item.is_initial_flat_fee ? 'Fee' : 'Percentage';
                });
            });
        },
        addNewFee: function addNewFee() {
            this.lateFee.property_id = this.$store.state.selectedProperty;
            this.showForm = true;
        },
        editLateFee: function editLateFee(item) {
            var _this2 = this;

            this.lateFee = Object.assign({}, item);
            this.lateFee.starts_at = moment(item.starts_at).format('MM/DD/YYYY');
            this.lateFee.ends_at = item.ends_at ? moment(item.ends_at).format('MM/DD/YYYY') : '';
            this.lateFee.initial_accounting_charge_code = this.chargeCodes.find(function (code) {
                return code.id === _this2.lateFee.initial_accounting_charge_code_id;
            });
            this.lateFee.daily_accounting_charge_code = this.chargeCodes.find(function (code) {
                return code.id === _this2.lateFee.daily_accounting_charge_code_id;
            });
            this.lateFee.is_initial_flat_fee = this.lateFee.is_initial_flat_fee === 1;
            this.lateFee.should_charge_lease_amount = item.should_charge_lease_amount === 1;

            this.lateFee.round_to_nearest_dollar = item.round_to_nearest_dollar === 1;
            this.showForm = true;
        },
        deleteLateFee: function deleteLateFee(item) {
            Event.$emit('confirm-delete', item, '/prototype/late-fees/delete/' + item.id_late_fees, 'delete-property-late-fee', 'Are you sure you want to delete this setting?', 'Delete');
        },
        confirmDeleteLateFee: function confirmDeleteLateFee(item, idx) {
            this.load();
        },
        save: function save() {
            var _this3 = this;

            // accomodate for stupid ass v-select component
            this.lateFee.initial_accounting_charge_code_id = this.lateFee.initial_accounting_charge_code.id;
            this.lateFee.daily_accounting_charge_code_id = this.lateFee.daily_accounting_charge_code.id;

            // if the late fee has an ID, let's update it
            if (this.lateFee.id_late_fees) {
                axios.post('/prototype/late-fees/update/' + this.lateFee.id_late_fees, this.lateFee).then(function () {
                    _this3.showForm = false;
                    _this3.load();
                });

                // if not, then we can assume it's new
            } else {
                axios.post('/prototype/late-fees/store', this.lateFee).then(function () {
                    _this3.showForm = false;
                    _this3.load();
                });
            }
        },
        close: function close() {
            Event.$emit('close-full-modal');
        }
    },

    created: function created() {
        Event.$on('property-settings-late-fees', this.load);
        Event.$on('add-property-late-fee', this.addNewFee);
        Event.$on('edit-property-late-fee', this.editLateFee);
        Event.$on('remove-property-late-fee', this.deleteLateFee);
        Event.$on('delete-property-late-fee', this.confirmDeleteLateFee);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('property-settings-late-fees');
        Event.$off('add-property-late-fee');
        Event.$off('edit-property-late-fee');
        Event.$off('remove-property-late-fee');
        Event.$off('delete-property-late-fee');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsLateFees.vue
// module id = 6592
// module chunks = 0 1